module.exports = "<div> <ul> <ng-content></ng-content> </ul> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/components/generic/navigation-menu/navigation-menu.component.html
// module id = 212
// module chunks = 0